// A pending product invite as returned by ADMIN_GET_COST_CENTER_INVITES - the active
// UserProductInviteV3 records for one cost center (libs/portal-core user-product-invite-v3).
// Every product on the cost center shares this list, so `productAccessId` is what ties an invite
// to a single license. The backend validates the full record; only the fields portal-web reads or
// displays are required here.
export interface CostCenterInvite {
  id: string;
  costCenterId: string;
  productAccessId: string;
  userId?: string | null;
  emailAddress?: string | null;
  firstname?: string | null;
  lastname?: string | null;
  costCenterName?: string | null;
  productAccessName?: string | null;
  inviterId?: string | null;
  ttlSeconds?: number | null;
  isCancelled?: boolean;
  phantom?: boolean;
  createdAt?: number | string;
  updatedAt?: number | string;
}

// How many of a cost center's invites belong to one license (productAccess).
export const countInvitesForProductAccess = (
  invites: Iterable<CostCenterInvite> | undefined,
  productAccessId: string | undefined,
): number => {
  let count = 0;
  Array.from(invites ?? []).forEach((invite) => {
    if (invite.productAccessId === productAccessId) count += 1;
  });
  return count;
};
